import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import UpdateUserSettingsRequest = App.Http.Requests.UserSetting.UpdateUserSettingsRequest;
import GetUserSettingsResponse = App.Http.Responses.UserSetting.GetUserSettingsResponse;

class UserSettingApi extends TenantBaseApi {
    /**
     * Update (upsert) one or more settings for a given user.
     *
     * - Request: UpdateUserSettingsRequest
     * - Response: GetUserSettingsResponse
     */
    async update(userId: string, request: UpdateUserSettingsRequest): Promise<GetUserSettingsResponse> {
        return await this.put<GetUserSettingsResponse, UpdateUserSettingsRequest>(
            `/users/settings/${userId}`,
            request
        );
    }
}

export const userSettingApi = new UserSettingApi();
